import { FC, useContext, useEffect } from "react";
import { clone, filter, pullAt } from "lodash";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { AppContext } from "../../../../contexts";

const NOTIFICATION_TIMEOUT = 8000;

const Notifications: FC = () => {
  const { notificationMessages, setNotificationMessages } = useContext(
    AppContext,
  );

  useEffect(() => {
    let timer: any = null;

    if (notificationMessages && notificationMessages.length > 0) {
      const warnings = filter(
        notificationMessages,
        notification => notification.tag === "warning",
      );

      timer = setTimeout(
        () => setNotificationMessages(warnings),
        NOTIFICATION_TIMEOUT,
      );
    }
    return () => clearTimeout(timer);
  }, [notificationMessages, setNotificationMessages]);

  const removeNotification = (index: number) => () => {
    const notificationMessagesClone = clone(notificationMessages);
    pullAt(notificationMessagesClone, [index]);
    setNotificationMessages(notificationMessagesClone);
  };

  return (
    <div className="es-notifications -visible">
      <TransitionGroup appear>
        {notificationMessages &&
          notificationMessages.length > 0 &&
          notificationMessages.map((notificationMessage, i) => (
            <CSSTransition
              key={"notification" + i}
              timeout={720}
              classNames="notification-message"
            >
              <div className={"-item -" + notificationMessage.tag}>
                <div className="text -sub -light">
                  {notificationMessage.message}
                </div>
                <div className="-close" onClick={removeNotification(i)}>
                  <div
                    className="-icon"
                    data-dismiss="alert"
                    aria-label="close"
                  >
                    <span></span>
                  </div>
                </div>
              </div>
            </CSSTransition>
          ))}
      </TransitionGroup>
    </div>
  );
};

export default Notifications;
